export default "__VITE_ASSET__565bb1fd__"